import type { FaireProductEntity } from "../../entity_types/product";

export const p_d91pgf7uyk: FaireProductEntity = {
  token: "p_d91pgf7uyk",
  type: "product",
  name: "Gedeb, Ethiopia — Organic Certified",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/f2dbdc284f06a367941fbc1774711a39258b3b540f27adf574055d12b1db643a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6c1bdf8f40a91640359faef80a405a33111e10738eaad237ef824211bcd36f6.jpeg",
    "https://cdn.faire.com/fastly/7502d82880ee103b3194e20b3952cca671ada1290fe2b975c79d52c68e68a617.jpeg",
    "https://cdn.faire.com/fastly/f48f9c894be1771786deb993cc165b76e59c5de64af527ace40f1550491429a0.jpeg"
  ],
  priceDollars: 13.2,
  description: "Available year round, from the Gedeb region in Ethiopia. We love coffees from this area for their fragrant, floral aroma, sweet, balanced taste, and smooth lime-like acidity.\n\n𝐀𝐛𝐨𝐮𝐭 𝐆𝐞𝐝𝐞𝐛\n• Origin: Ethiopia\n• Producer: SNAP (Negusse Debela)\n• Region: Gedeb\n• Process: Washed\n• Certification: Organic\n• We Taste: Persimmon, Lime and Bergamot\n\n𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞\nThe cup is deliciously sweet and round, with a smooth lime-like acidity. The broadest note we picked up on hearkened to fuyu persimmons — Ally's favorite fruit. When ripe, we love persimmons for their developed autumnal sweetness, which is almost honey-like. They seem to carry a trace of cinnamon.",
  tags: [],
  msrpDollars: 26.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:50.697Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
